<template>
  <!-- eslint-disable max-len -->
  <main id="about-page">
    <ContentTitle :category="$t('sideMenu.ClientInventory')" :categoryIcon="'scf-patrimoine'"
      :title="$t('pages.DeviceDetails.Title')" /><br /><br />

    <nav>
      <div class="nav nav-tabs nav-fill" id="nav-tab" role="tablist">
        <button :class="targetTab == 'timeline' ? '' : 'active'" class="nav-link" id="nav-home-tab" data-bs-toggle="tab"
          data-bs-target="#nav-home" type="button" role="tab" aria-controls="nav-home"
          :aria-selected="targetTab == null">
          {{ $t("pages.DeviceDetails.DeviceCard") }}
        </button>
        <button :class="targetTab == 'timeline' ? 'active' : ''" class="nav-link" id="nav-profile-tab"
          data-bs-toggle="tab" data-bs-target="#nav-profile" type="button" role="tab" aria-controls="nav-profile"
          :aria-selected="targetTab == 'timeline'">
          {{ $t("pages.DeviceDetails.Timeline") }}
        </button>
      </div>
    </nav>
    <div class="tab-content" id="nav-tabContent">
      <div :class="targetTab == 'timeline' ? '' : 'show active'" class="tab-pane fade-in" id="nav-home" role="tabpanel"
        aria-labelledby="nav-home-tab">
        <br />

        <!-- //! Begin Main card for principal device ######################################################################################## -->
        <!-- //* Begin new Main card for principal device ************************************************************************************ -->
        <card :title="(!this.DeviceType ||
          !this.translationExists('pages.DeviceDetails.' + this.DeviceType)
          ? ''
          : this.$t('pages.DeviceDetails.' + this.DeviceType)
        ).concat(
          ' ',
          this.PreAssembly !== null
            ? this.MainCardTitle != null
              ? this.MainCardTitle
              : this.ExternalId //this.ExternalId //this.PreAssembly.TransmitterManufacturerGuid // ?  //
            : ''
        )
          " :styles="''" :icon="{ class: 'scf-vector', styles: 'padding:5px;' }" :enableCollapse="true"
          :fullScreen="false">
          <template v-slot:card-edit>
            <button class="btn btn-sm save-button ml-2" @click.prevent="UpdateParameters"
              v-show="Object.keys(this.modifiedParams).length > 0">
              <i class="scf-save" />
              {{ $t('common.save') }}
            </button>
          </template>

          <template v-slot:card-drop-down> </template>

          <template v-slot:card-body-title> </template>

          <template v-slot:card-body-container>
            <div class="card-body">
              <!-- //! to put -->
              <div class="row">
                <div :class="this.CardData.length == 1
                  ? 'col-md-12'
                  : this.CardData.length == 2
                    ? 'col-md-6'
                    : 'col-md-4'
                  " style="padding-top: 10px" v-for="(item, index) in this.CardData" v-bind:key="index">
                  <card-info :Id="item.Index" :title="this.GetParameterTraductionForTitleCard(item.Key)"
                    :items="GetCustomDetails(item.Parameters)" :type="item.Type" :dataModel="item.DataModel"
                    :classCSS="item.Icon" :Collapsed="false" @eventemit="showdatafromchild"></card-info>
                </div>
              </div>
              <!-- pairing history                  --------------------------------------------------------------------- -->
              <div class="row" v-if="PairingHistory">
                <div class="col-md-12" style="padding-top: 10px">
                  <card :id="777" :bgColor="'#FFFFFF'" :title="this.GetParameterTraductionForTitleAdditionalCard(
                    'PairingHistory'
                  )
                    " :styles="'small'" :icon="{
                      class: 'scf-additional-params',
                      styles: 'padding:5px;',
                    }" :enableCollapse="true" :fullScreen="false">
                    <template v-slot:card-edit> </template>

                    <template v-slot:card-drop-down> </template>

                    <template v-slot:card-body-title> </template>

                    <template v-slot:card-body-container>
                      <div class="card-body">
                        <div class="row row-padding-bottom-10" v-if="componentKey > 0">
                          <OdataFlexGrid :key="componentKey" :Api="{
                            base: urlOdata + 'api/v1/OData/',
                            controller:
                              'devicePairings?deviceId=' + this.deviceId,
                          }" :requestHeaders="gridHeaders" :FiltersDefinition="FiltersDefinitionPairing"
                            :ColumnsDefinition="columnsPairing" :FilterColumns="[
                              'Id',
                              'TransmitterId',
                              'TransmitterIdentifier',
                              'TransmitterAlternateIdentifier',
                              'TransmitterRadioMode',
                              'ElectronicIndex',
                              'MechanicalIndex',
                              'PulseWeight',
                              'MountingDate',
                              'Source',
                            ]" :GridHeight="'250px'" :displayLang="culture"
                            v-on:initializedGrid="gridPairingInitialized"
                            v-on:gridFilterChanged="gridPairingFilterChanged" :GridId="'pairingHistory-v16'"
                            :ExportsButtons="{
                              Id: 100,
                              Header: ExportsHeaderPairing,
                              DataSource: ExportsDataSourcePairing,
                              Events: ExportsEventsPairing,
                            }" :WijmoLicense="config.value('VUE_APP_WIJMO_LICENCE')
                              " v-on:format-columns="formatColumnsPairing"
                            v-on:column-visibility-changed="componentKey++" />
                        </div>
                      </div>
                    </template>
                    <template v-slot:card-footer> </template>
                  </card>
                </div>
              </div>
              <!--  fin additionnal parameters #################################    -->
              <!-- association history                  --------------------------------------------------------------------- -->
              <div class="row" v-if="AssociationHistory">
                <div class="col-md-12" style="padding-top: 10px">
                  <card :id="778" :bgColor="'#FFFFFF'" :title="this.GetParameterTraductionForTitleAdditionalCard(
                    'AssociationHistory'
                  )
                    " :styles="'small'" :icon="{
                      class: 'scf-additional-params',
                      styles: 'padding:5px;',
                    }" :enableCollapse="true" :fullScreen="false">
                    <template v-slot:card-edit> </template>

                    <template v-slot:card-drop-down> </template>

                    <template v-slot:card-body-title> </template>

                    <template v-slot:card-body-container>
                      <div class="card-body">
                        <div class="row row-padding-bottom-10" v-if="componentKey > 0">
                          <OdataFlexGrid :key="componentKey" :Api="{
                            base: urlOdata + 'api/v1/OData/',
                            controller: `DeviceAssociations?deviceId=${this.deviceId}&type=${this.DeviceType}`,
                          }" :requestHeaders="gridHeaders" :FiltersDefinition="FiltersDefinitionAssociation"
                            :ColumnsDefinition="columnsAssociation" :FilterColumns="[
                              'Id',
                              'ServicePointId',
                              'ServicePointIdentifier',
                              'TransmitterId',
                              'TransmitterIdentifier',
                              'TransmitterAlternateIdentifier',
                              'TransmitterInstallingDate',
                              'TransmitterUninstallingDate',
                              'SensorId',
                              'SensorIdentifier',
                              'SensorInstallDate',
                              'SensorUninstallDate',
                              'CreatedDate',
                              'Source',
                            ]" :GridHeight="'250px'" :displayLang="culture" v-on:gridFilterChanged="
                              gridAssociationFilterChanged
                            " :GridId="'AssociationHistory-v6'" :ExportsButtons="{
                              Id: 101,
                              Header: ExportsHeaderAssociation,
                              DataSource: ExportsDataSourceAssociation,
                              Events: ExportsEventsAssociation,
                            }" :WijmoLicense="config.value('VUE_APP_WIJMO_LICENCE')
                              " v-on:format-columns="formatColumnsAssociation"
                            v-on:column-visibility-changed="componentKey++" />
                        </div>
                      </div>
                    </template>
                    <template v-slot:card-footer> </template>
                  </card>
                </div>
              </div>
              <!--  fin history association  #################################    -->
              <!-- Additionnal parameters                  --------------------------------------------------------------------- -->
              <div class="row" v-if="UnclassifiedParameters">
                <div class="col-md-12" style="padding-top: 10px">
                  <card :id="100" :bgColor="'#FFFFFF'" :title="this.GetParameterTraductionForTitleAdditionalCard(
                    'UnclassifiedParameters'
                  )
                    " :styles="'small'" :icon="{
                      class: 'scf-additional-params',
                      styles: 'padding:5px;',
                    }" :enableCollapse="true" :fullScreen="false">
                    <template v-slot:card-edit> </template>

                    <template v-slot:card-drop-down> </template>

                    <template v-slot:card-body-title> </template>

                    <template v-slot:card-body-container>
                      <div class="card-body">
                        <div class="row row-padding-bottom-10">
                          <AdditionalDataGrid :rawData="additionalData" :externalId="ExternalId" />
                        </div>
                      </div>
                    </template>
                    <template v-slot:card-footer> </template>
                  </card>
                </div>
              </div>
              <!--  fin additionnal parameters ################################# -->
            </div>
          </template>
          <template v-slot:card-footer> </template>
        </card>
        <!-- //* End  new Main card for principal device  ************************************************************************************* -->

        <br />
        <div v-for="(item, index) in this.IsAnotherDevices" v-bind:key="index">
          <main-card v-if="item.Title" :Id="item.Id" :title="item.Title" :identifier="item.Value" :type="item.Type"
            :dataModel="item.DataModel" :items="item.Cards" :hasUnclassifiedParameters="item.hasUnclassifiedParameters"
            :hasPairingHistory="item.hasPairingHistory" :hasAssociationHistory="item.hasAssociationHistory"
            :ErrorMessages="this.errorMessages"></main-card>
          <br />
        </div>
        <!-- ####################################################### dessous main car -->

        <!-- end -->
      </div>
      <div :class="targetTab == 'timeline' ? 'show active' : ''" class="tab-pane fade-in" id="nav-profile"
        role="tabpanel" aria-labelledby="nav-profile-tab">
        <br />
        <!-- <timeline></timeline> -->
        <div class="row d-flex justify-content-center" style="width: calc(100% - 20px); margin-left: 10px">
          <card-box :type="this.DeviceType" :identifier="this.ExternalId"></card-box>
          <card-box class="secondary-card" v-for="(item, index) in this.IsAnotherDevices" v-bind:key="index"
            :type="item.Type" :identifier="item.Value" @click="goToDeviceDetails(item.Type, item.Id)"></card-box>
        </div>

        <div class="row d-flex justify-content-center mt-70 mb-70">
          <div class="col-md-6">
            <div class="main-card mb-3 card-timeline">
              <div class="card-body">
                <h5 class="card-title"></h5>
                <div class="vertical-timeline vertical-timeline--animate vertical-timeline--one-column"
                  v-if="loadedTimeLine">
                  <div v-for="(item, index) in this.transactionItems" v-bind:key="index">
                    <!-- {{this.DataModel}} -->
                    <timeline-item :Id="index" :Date="item.CreatedDate" :SourceType="item.Source"
                      :Source="item.TransactionSource" :createdUser="item.createdUser"
                      :items="applyFiltersOnTransactions(item.DeviceParameterTransactionValues)" :color="item.Color"
                      :Status="item.Status" :ImportId="item.DeviceImportId" :ErrorMessages="item.ErrorMessages"
                      :DataModel="item.DataModel" :Scope="currentScopeView"></timeline-item>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <firmware-list></firmware-list> -->
    <wj-popup style="width: 20%" class="wj-popup" role="dialog" :initialized="initCountRowsPopup">
      <div class="modal-header wj-dialog-header header-countRowsPopup">
        <h5>
          {{ this.$t("pages.DeviceDetails.PairingHistory.TitleCountRows") }}
        </h5>
      </div>
      <div class="modal-body wj-dialog-body body-countRowsPopup">
        <p>
          {{ this.showCountRowsMessage }}
          {{ this.$t("common.showCountRecords") }}
        </p>
      </div>
      <div class="modal-footer wj-dialog-footer footer-countRowsPopup">
        <button class="btn btn-primary wj-btn, wj-hide-ok button-countRowsPopup">
          OK
        </button>
      </div>
    </wj-popup>
  </main>
</template>

<script>
import { defineComponent, computed } from "vue";
import Swal from "sweetalert2";
import Configs from "../../configs";
import XlsExport from "../Utils/xls-export.js";
import glyphDown from "../assets/icons/wj-glyph-down.svg";
import Helper from "@/Utils/Helper";
import CardInfo from "../components/Card.vue";
import MainCard from "../components/MainCard.vue";
import CardBox from "../components/CardBox.vue";
import TimelineItem from "../components/Timeline.vue";
import EquipmentDto from "../DTO/Equipment";
import CardModel from "../DTO/Card";
import AnotherEquipment from "../DTO/AnotherEquipment";
import Transaction from "../DTO/Transaction";
import { WjPopup } from "@grapecity/wijmo.vue2.input";
import { Globalize } from "@grapecity/wijmo";
import * as wijmo from "@grapecity/wijmo";
import OdataFlexGrid from "@supervision/vue-components/components/OdataFlexGrid.vue";

import AdditionalDataGrid from "@/components/atoms/AdditionalDataGrid.vue";

//import mockedData from "../mock/tmp";
import MainService from "../services/MainService";
import utils from "../Utils/libraries";
import ContentTitle from "@supervision/vue-components/components/ContentTile";
import card from "@supervision/vue-components/components/Card.vue";
export default defineComponent({
  name: "EquipmentDetails",
  inject: ["accessToken", "routePrefix", "currentScope"],
  components: {
    CardInfo,
    TimelineItem,
    WjPopup,
    MainCard,
    ContentTitle,
    OdataFlexGrid,
    CardBox,
    card,
    AdditionalDataGrid,
    // FirmwareList,
  },
  watch: {
    treatedTransactions(newVal) {
      if (newVal && newVal == this.transactions.length) {
        this.preloadedTransactionItems.sort(
          (a, b) => Date.parse(b.CreatedDate) - Date.parse(a.CreatedDate)
        );
        this.transactionItems = this.preloadedTransactionItems;
      }
    },
    currentScope: {
      handler: function (newVal) {
        this.refreshContent(newVal);
      },
      deep: true,
    },
    accessToken(newVal) {
      if (newVal) {
        this.mainService = new MainService(newVal, this.currentScopeView);
      }
    },
    anotherEquipementFull(newVal) {
      if (newVal) {
        // this.MethodElliFihaTraitement()
        this.anotherEquipementFull = false;
      }
    },
    culture() {
      if (this.currentScopeView != null && this.currentScopeView !== "")
        this.componentKey += 1;
    },
  },
  computed: {
    currentScopeView() {
      return this.preselectedScope ?? this.currentScope ?? this.$jwt.scope;
    },
    gridHeaders() {
      return {
        authorization: `bearer ${this.accessToken}`,
        'X-Current-Scope': this.currentScopeView,
        'X-Custom-Filters': computed(() => this.headerFilters),
      };
    }
  },
  data() {
    return {
      componentKey: 0,
      mainService: new MainService(this.$jwt.token, this.currentScope),
      config: Configs,
      loadedTimeLine: false,
      theGrid: null,
      targetTab: null,
      culture: computed(() => this.$i18n.locale),
      urlOdata: Configs.value("VUE_APP_WEBAPI"),
      filter: null,
      listAnotherEquipment: [],
      anotherEquipementFull: false,
      baseDeviceType: "",
      LifeCycleLabelTraductions: [
        { culture: "fr-FR", value: "Etat" },
        { culture: "en-US", value: "State" },
        { culture: "en-GB", value: "State" },
      ],
      FiltersDefinitionPairing: [
        {
          binding: "Id",
          hasValueFilter: false,
          hasConditionFilter: true,
        },
        {
          binding: "TransmitterId",
          hasValueFilter: false,
          hasConditionFilter: true,
        },
        {
          binding: "TransmitterIdentifier",
          hasValueFilter: false,
          hasConditionFilter: true,
        },
        {
          binding: "TransmitterAlternateIdentifier",
          hasValueFilter: false,
          hasConditionFilter: true,
        },
        {
          binding: "TransmitterRadioMode",
          hasValueFilter: true,
          hasConditionFilter: false,
          values: [
            {
              id: "1G",
              label: computed(() =>
                this.tryGetTranslation("RadioProtocols.1G")
              ),
            },
            {
              id: "2G",
              label: computed(() =>
                this.tryGetTranslation("RadioProtocols.2G")
              ),
            },
            {
              id: "G3BIRDZ",
              label: computed(() =>
                this.tryGetTranslation("RadioProtocols.G3BIRDZ")
              ),
            }
          ],
        },
        {
          binding: "ElectronicIndex",
          hasValueFilter: false,
          hasConditionFilter: true,
        },
        {
          binding: "MechanicalIndex",
          hasValueFilter: false,
          hasConditionFilter: true,
        },
        {
          binding: "PulseWeight",
          hasValueFilter: false,
          hasConditionFilter: true,
        },
        {
          binding: "MountingDate",
          hasValueFilter: false,
          hasConditionFilter: true,
        },
        {
          binding: "Source",
          hasValueFilter: true,
          hasConditionFilter: false,
          values: [
            {
              id: "Manufacturer",
              label: computed(() =>
                this.getTraductionTransactionSource("Manufacturer")
              ),
            },
            {
              id: "Mobility",
              label: computed(() =>
                this.getTraductionTransactionSource("Mobility")
              ),
            },
            {
              id: "Manual",
              label: computed(() =>
                this.getTraductionTransactionSource("Manual")
              ),
            },
            {
              id: "Assets",
              label: computed(() =>
                this.getTraductionTransactionSource("Assets")
              ),
            },
            {
              id: "Cancelation",
              label: computed(() =>
                this.getTraductionTransactionSource("Cancelation")
              ),
            },
          ],
        },
      ],
      ExportsHeaderPairing: { text: "Exports", icon: "scf-export" },
      ExportsDataSourcePairing: [
        { text: "Export as Csv", method: "exportCsvPairing", icon: "scf-csv" },
        {
          text: "Export as Excel",
          method: "exportExcelPairing",
          icon: "scf-excel",
        },
      ],
      ExportsEventsPairing: {
        exportCsvPairing: this.exportCsvPairing,
        exportExcelPairing: this.exportExcelPairing,
      },
      columnsPairing: [
        {
          binding: "Id",
          width: "*",
          header: computed(() =>
            this.$t("pages.DeviceDetails.PairingHistory.columns.Id")
          ),
          visible: false,
        },
        {
          binding: "TransmitterId",
          width: "*",

          header: computed(() =>
            this.$t("pages.DeviceDetails.PairingHistory.columns.TransmitterId")
          ),
          visible: false,
        },
        {
          binding: "TransmitterIdentifier",
          width: "*",

          header: computed(() =>
            this.$t(
              "pages.DeviceDetails.PairingHistory.columns.TransmitterIdentifier"
            )
          ),
        },
        {
          binding: "TransmitterAlternateIdentifier",
          width: "*",

          header: computed(() =>
            this.$t(
              "pages.DeviceDetails.PairingHistory.columns.TransmitterAlternateIdentifier"
            )
          ),
        },
        {
          binding: "TransmitterRadioMode",
          width: "*",

          header: computed(() =>
            this.$t(
              "pages.DeviceDetails.PairingHistory.columns.TransmitterRadioMode"
            )
          ),
        },
        {
          binding: "ElectronicIndex",
          width: "*",
          header: computed(() =>
            this.$t(
              "pages.DeviceDetails.PairingHistory.columns.ElectronicIndex"
            )
          ),
        },
        {
          binding: "MechanicalIndex",
          width: "*",
          header: computed(() =>
            this.$t(
              "pages.DeviceDetails.PairingHistory.columns.MechanicalIndex"
            )
          ),
        },
        {
          binding: "PulseWeight",
          width: "*",
          header: computed(() =>
            this.$t("pages.DeviceDetails.PairingHistory.columns.PulseWeight")
          ),
        },
        {
          binding: "Source",
          width: "*",
          header: "Source",
        },
        {
          binding: "MountingDate",
          width: "*",
          dataType: 4,
          format: "MM/dd/yyyy",
          header: computed(() =>
            this.$t("pages.DeviceDetails.PairingHistory.columns.PairingDate")
          ),
        },
        { header: "Actions", width: "*" },
      ],
      FiltersDefinitionAssociation: [
        {
          binding: "Id",
          hasValueFilter: false,
          hasConditionFilter: true,
        },
        {
          binding: "ServicePointId",
          hasValueFilter: false,
          hasConditionFilter: true,
        },
        {
          binding: "ServicePointIdentifier",
          hasValueFilter: false,
          hasConditionFilter: true,
        },
        {
          binding: "TransmitterId",
          hasValueFilter: false,
          hasConditionFilter: true,
        },
        {
          binding: "TransmitterIdentifier",
          hasValueFilter: false,
          hasConditionFilter: true,
        },
        {
          binding: "TransmitterAlternateIdentifier",
          hasValueFilter: false,
          hasConditionFilter: true,
        },
        {
          binding: "TransmitterInstallingDate",
          hasValueFilter: false,
          hasConditionFilter: true,
        },
        {
          binding: "TransmitterUninstallingDate",
          hasValueFilter: false,
          hasConditionFilter: true,
        },
        {
          binding: "SensorId",
          hasValueFilter: false,
          hasConditionFilter: true,
        },
        {
          binding: "SensorIdentifier",
          hasValueFilter: false,
          hasConditionFilter: true,
        },
        {
          binding: "SensorInstallDate",
          hasValueFilter: false,
          hasConditionFilter: true,
        },
        {
          binding: "SensorUninstallDate",
          hasValueFilter: false,
          hasConditionFilter: true,
        },
        {
          binding: "CreatedDate",
          hasValueFilter: false,
          hasConditionFilter: true,
        },
        {
          binding: "Source",
          hasValueFilter: true,
          hasConditionFilter: false,
          values: [
            {
              id: "Manufacturer",
              label: computed(() =>
                this.getTraductionTransactionSource("Manufacturer")
              ),
            },
            {
              id: "Mobility",
              label: computed(() =>
                this.getTraductionTransactionSource("Mobility")
              ),
            },
            {
              id: "Manual",
              label: computed(() =>
                this.getTraductionTransactionSource("Manual")
              ),
            },
            {
              id: "Assets",
              label: computed(() =>
                this.getTraductionTransactionSource("Assets")
              ),
            },
            {
              id: "Cancelation",
              label: computed(() =>
                this.getTraductionTransactionSource("Cancelation")
              ),
            },
          ],
        },
      ],
      ExportsHeaderAssociation: { text: "Exports", icon: "scf-export" },
      ExportsDataSourceAssociation: [
        {
          text: "Export as Csv",
          method: "exportCsvAssociation",
          icon: "scf-csv",
        },
        {
          text: "Export as Excel",
          method: "exportExcelAssociation",
          icon: "scf-excel",
        },
      ],
      ExportsEventsAssociation: {
        exportCsvAssociation: this.exportCsvAssociation,
        exportExcelAssociation: this.exportExcelAssociation,
      },
      columnsAssociation: [
        {
          binding: "Id",
          width: "*",
          header: computed(() =>
            this.$t("pages.DeviceDetails.AssociationHistory.columns.Id")
          ),
          visible: false,
          isTechnicalColumn: true,
        },
        {
          width: "*",
          header: computed(() => this.$t("pages.FirmwareList.columns.Source")),
          binding: "Source",
          dataType: 1,
          visible: true,
        },
        {
          binding: "ServicePointId",
          width: "*",

          header: computed(() =>
            this.$t(
              "pages.DeviceDetails.AssociationHistory.columns.ServicePointId"
            )
          ),
          visible: false,
          isTechnicalColumn: true,
        },
        {
          binding: "ServicePointIdentifier",
          width: "*",

          header: computed(() =>
            this.$t(
              "pages.DeviceDetails.AssociationHistory.columns.ServicePointIdentifier"
            )
          ),
        },
        {
          binding: "TransmitterId",
          width: "*",

          header: computed(() =>
            this.$t(
              "pages.DeviceDetails.AssociationHistory.columns.TransmitterId"
            )
          ),
          visible: false,
          isTechnicalColumn: true,
        },
        {
          binding: "TransmitterIdentifier",
          width: "*",

          header: computed(() =>
            this.$t(
              "pages.DeviceDetails.AssociationHistory.columns.TransmitterIdentifier"
            )
          ),
        },
        {
          binding: "TransmitterAlternateIdentifier",
          width: "*",
          header: computed(() =>
            this.$t(
              "pages.DeviceDetails.AssociationHistory.columns.TransmitterAlternateIdentifier"
            )
          ),
        },
        {
          binding: "TransmitterInstallingDate",
          width: "*",
          dataType: 4,
          header: computed(() =>
            this.$t(
              "pages.DeviceDetails.AssociationHistory.columns.TransmitterInstallingDate"
            )
          ),
        },
        {
          binding: "TransmitterUninstallingDate",
          width: "*",
          dataType: 4,
          header: computed(() =>
            this.$t(
              "pages.DeviceDetails.AssociationHistory.columns.TransmitterUninstallingDate"
            )
          ),
        },
        {
          binding: "SensorId",
          width: "*",
          header: computed(() =>
            this.$t("pages.DeviceDetails.AssociationHistory.columns.SensorId")
          ),
          visible: false,
          isTechnicalColumn: true,
        },
        {
          binding: "SensorIdentifier",
          width: "*",
          header: computed(() =>
            this.$t(
              "pages.DeviceDetails.AssociationHistory.columns.SensorIdentifier"
            )
          ),
        },
        {
          binding: "SensorInstallDate",
          width: "*",
          dataType: 4,
          header: computed(() =>
            this.$t(
              "pages.DeviceDetails.AssociationHistory.columns.SensorInstallDate"
            )
          ),
        },
        {
          binding: "SensorUninstallDate",
          width: "*",
          dataType: 4,
          header: computed(() =>
            this.$t(
              "pages.DeviceDetails.AssociationHistory.columns.SensorUninstallDate"
            )
          ),
        },
        {
          binding: "CreatedDate",
          width: "*",
          dataType: 4,
          header: computed(() =>
            this.$t(
              "pages.DeviceDetails.AssociationHistory.columns.CreatedDate"
            )
          ),
        },
        { header: "Actions", width: "*" },
      ],

      latestFilter: { ValueFilters: [], ConditionFilters: [] },
      columns: [
        //Define how your columns should look like
        {
          binding: "Label",
          width: "*",
          header: "Label",
          isReadOnly: true,
        },
        {
          binding: "Value",
          width: "*",
          header: "Value",
          isReadOnly: true,
        },
        {
          binding: "HexadecimalAdress",
          width: "*",
          header: "HexadecimalAdress",
          isReadOnly: true,
        },
        {
          binding: "Source",
          width: "*",
          header: "Source",
          isReadOnly: true,
        },
        {
          binding: "Actions",
          width: "*",
          header: "Actions",
          isReadOnly: true,
        },
      ],
      FiltersDefinition: [
        //Define how filters should look like
        {
          binding: "HexadecimalAdress",
          hasValueFilter: false,
          hasConditionFilter: true,
        },
        {
          binding: "Value",
          hasValueFilter: false,
          hasConditionFilter: true,
        },
        {
          binding: "Label",
          hasValueFilter: false,
          hasConditionFilter: true,
        },
        {
          binding: "Source",
          hasValueFilter: true,
          hasConditionFilter: false,
          values: [
            { id: "Fabricant", label: "Manufacturer" },
            { id: "Mobilité", label: "Mobility" },

            { id: "", label: "Null" },
          ],
        },
      ],
      Collection: [
        {
          Label: "Parameter 1",
          Value: "1",
          HexadecimalAdress: "-",
          Source: "Manufacturer",
        },
        {
          Label: "Parameter 2",
          Value: "2",
          HexadecimalAdress: "-",
          Source: "Manufacturer",
        },
      ],
      ExportsDataSource: [
        { text: "Export as Csv", method: "exportCsv", icon: "scf-csv" },
        { text: "Export as Excel", method: "exportExcel", icon: "scf-excel" },
      ],
      ExportsEvents: {
        exportCsv: this.exportCsv,
        exportExcel: this.exportExcel,
      },
      ExportsDataSourceUnclassifiedParameters: [
        {
          text: "Export as Csv",
          method: "exportCsvUnclassifiedParameters",
          icon: "scf-csv",
        },
        {
          text: "Export as Excel",
          method: "exportExcelUnclassifiedParameters",
          icon: "scf-excel",
        },
      ],
      ExportsEventsUnclassifiedParameters: {
        exportCsvUnclassifiedParameters: this.exportCsvUnclassifiedParameters,
        exportExcelUnclassifiedParameters:
          this.exportExcelUnclassifiedParameters,
      },
      showCountRowsMessage: "",
      glyphDown: glyphDown,
      EquipmentDto: EquipmentDto,
      CardModel: CardModel,
      DataModel: null,
      deviceId: null,
      Transaction: Transaction,
      transactions: [],
      CardData: [],
      IsAnotherDevices: [],
      IndexAnotherDeviceCards: 100,
      UnclassifiedParameters: false,
      PairingHistory: false,
      AssociationHistory: false,
      PreAssembly: null,
      transactionItems: [],
      preloadedTransactionItems: [],
      treatedTransactions: 0,
      ExternalId: null,
      DeviceType: null,
      MainCardTitle: null,
      SecondCardTitle: null,
      SourcesColor: [
        {
          Key: "Manufacturer",
          Value: "#6095D6",
        },
        {
          Key: "DeviceImport",
          Value: "#FF69B4",
        },
        {
          Key: "FirmwareCampagne",
          Value: "#FFC229",
        },
        {
          Key: "Manual",
          Value: "#262217",
        },
        {
          Key: "MonitoringFrame",
          Value: "#038005",
        },
      ],
      FunctionalSectionIcons: [
        {
          Key: "CoreInformations",
          Value: "scf-info icon",
        },
        {
          Key: "Radio",
          Value: "scf-radio icon",
        },
        {
          Key: "MeterPairing",
          Value: "scf-pairing icon",
        },
        {
          Key: "Measurement",
          Value: "scf-measurement icon",
        },
        {
          Key: "Metrological",
          Value: "scf-metrology icon",
        },
        {
          Key: "Metering",
          Value: "scf-meetering icon",
        },
        {
          Key: "Security",
          Value: "scf-security icon",
        },
        {
          Key: "OrderInfo",
          Value: "scf-security icon",
        },
        {
          Key: "Time",
          Value: "scf-clock icon",
        },
        {
          Key: "Pairing",
          Value: "scf-pairing icon",
        },
        {
          Key: "Location",
          Value: "scf-location icon",
        },
        {
          Key: "LifeCycleInfos",
          Value: "scf-info icon",
        },
      ],
      latestDataPairingState: null,
      latestDataAssociationState: null,
      exportPairingRoot:
        Configs.value("VUE_APP_WEBAPI") + "api/v1/OData/devicePairings/export?",
      exportAssociationRoot:
        Configs.value("VUE_APP_WEBAPI") +
        "api/v1/OData/DeviceAssociations/export?",
      modifiedParams: {},
      errorMessages: null,
      errorCode: null,
      additionalData: null,
    };
  },
  methods: {
    applyFiltersOnTransactions(itemTransactions) {
      const hiddenParameters = ["TransmitterGuid", "MeterModule1GIdentifier", "MeterDiameterInMillimeterDividedBy5"];
      return itemTransactions.filter(it => !hiddenParameters.includes(it.parameterName));
    },
    ContentHtmlForParams(data) {
      var Output = "";
      data.forEach((e) => {
        console.log(
          this.GetMessageError(
            e.errorCode,
            e.errorMessageValues,
            this.errorMessages
          )
        );
        Output += `${this.GetMessageError(
          e.errorCode,
          e.errorMessageValues,
          this.errorMessages
        )}</br></br>`;
      });
      return Output;
    },
    GetParameterTraductionForTitleCard(value) {
      var traduction = "";
      let x = this.CardData.filter((e) => e.Key == value);
      if (!utils.isEmpty(x)) {
        let trad;
        trad = x[0].Translations.filter((e) => e.culture == this.culture);
        if (!utils.isEmpty(trad)) {
          traduction = trad[0].value;
        } else {
          traduction = value;
        }
      }
      return traduction;
    },

    GetMessageError(errorCode, params, messagesList) {
      console.log(
        "🚀 ~ file: EquipmentDetail.vue:865 ~ GetMessageError ~ errorCode, params, messagesList",
        errorCode,
        params,
        messagesList
      );

      try {
        if (errorCode !== null && errorCode != "") {
          var message = messagesList.filter(
            (e) => e.key == `ErrorMessage_${errorCode}`
          )[0].value;

          if (params !== null) {
            var paramsArray = params.split(";");
            if (paramsArray.length > 1) {
              for (let i = 0; i < paramsArray.length; i++) {
                if (i == 0) {
                  message = message.replace(
                    `{${i}}`,
                    this.GetParameterTraductionForTimeLineElement(
                      paramsArray[i]
                    )
                  );
                } else {
                  message = message.replace(
                    `{${i}}`,
                    this.GetParameterTraductionForTimeLineElement(
                      paramsArray[i]
                    )
                  );
                }
              }
            } else if (paramsArray.length == 1) {
              message = message.replace(
                `{0}`,
                this.GetParameterTraductionForTimeLineElement(paramsArray[0])
              );
            }

            return errorCode + " " + message;
          }
          return errorCode + " " + message;
        }
      } catch (error) {
        console.log(
          "🚀 ~ file: EquipmentDetail.vue:905 ~ GetMessageError ~ error",
          error
        );
      }

      return "";
    },
    GetParameterTraductionForTimeLineElement(value) {
      let x = this.DataModel.deviceParameterDefinitions.filter(
        (e) => e.key == value
      );
      // let x = this.items.filter((e) => e.key == value);
      if (!utils.isEmpty(x)) {
        let trad;

        if (!utils.isEmpty(x[0].translations)) {
          trad = x[0].translations.filter((e) => e.culture == this.culture);
          if (!utils.isEmpty(trad)) {
            return trad[0].value;
          } else {
            return x.key;
          }
        }
      }
      return !this.translationExists("pages.DeviceDetails." + value)
        ? value
        : this.$t("pages.DeviceDetails." + value);
    },
    ContentHtmlForModifiedParams() {
      var Output = "";
      Object.keys(this.modifiedParams).forEach((key) => {
        Output =
          Output +
          `${this.translationExists("pages.DeviceDetails." + key)
            ? this.$t("pages.DeviceDetails." + key)
            : key
          }:${this.GetParametersTraductionValue(
            this.modifiedParams[key]
          )}</br>`;
        // if (this.modifiedParams[key] === null) {
        //   delete this.modifiedParams[key];
        // }
      });
      return `</br>${Output}</br>`;
    },
    UpdateParameters() {
      //TODO

      console.log(this.map(this.modifiedParams));

      Swal.fire({
        title: this.$t(
          "pages.FirmwareAdd.ErrorLabel.DoYouWantToSaveTheChanges"
        ),
        showDenyButton: true,
        html: this.ContentHtmlForModifiedParams(),
        showCancelButton: false,
        confirmButtonText: this.$t("common.save"),
        denyButtonText: this.$t("common.cancel"),
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          // alert(this.ExternalId);
          // alert(this.deviceId);
          // alert(this.DeviceType);
          //TODO send data and check result
          this.mainService
            .Sendparams(
              this.DeviceType,
              this.ExternalId,
              this.map(this.modifiedParams)
            )
            .then((response) => {
              //  console.log(response);
              console.log("response : ", response);
              if (
                typeof response.data != "undefined" &&
                response.data != null &&
                response.data != "" &&
                response.data.length != null &&
                response.data.length > 0
              ) {
                //TODO get message code

                //  Swal.fire("", this.ContentHtmlForParams(response.data), "info");
                Swal.fire({
                  title: "",
                  width: 600,
                  icon: "error",
                  html: this.ContentHtmlForParams(response.data),
                });
              } else {
                Swal.fire({
                  icon: "success",
                  title: this.$t(
                    "pages.FirmwareAdd.ErrorLabel.ParamsModifiedSuccessfuly"
                  ),
                  showConfirmButton: true,
                }).then(() => {
                  this.$router.go();
                });
              }
              //Votre demande de Descente de Firmware est envoyée ParamsModifiedSuccessfuly
            })
            .catch((error) => {
              console.log("error : ", error);
              Swal.fire(this.$t("pages.FirmwareAdd.ErrorLabel.Error"));
            })
            .finally(() => { });
          // Swal.fire("done", "", "success");
        } else if (result.isDenied) {
          //Swal.fire("Changes are not saved", "", "info");
        }
      });
    },
    //
    showdatafromchild(e, t) {
      console.log(t);
      if (e == null) {
        this.modifiedParams = {};
      }
      e.forEach((e) => {
        this.modifiedParams[e.Key] = e.Value;
      });

      Object.keys(this.modifiedParams).forEach((key) => {
        if (this.modifiedParams[key] === null) {
          delete this.modifiedParams[key];
        }
      });

      console.log("showdatafromchield", this.modifiedParams);
    },
    gridPairingFilterChanged(data) {
      this.latestDataPairingState = data;
    },
    gridAssociationFilterChanged(data) {
      this.latestDataAssociationState = data;
    },
    goToDeviceDetails(type, technicalId) {
      const prefix = Helper.ComputeRoutePrefix(this.routePrefix);
      window.location.href = `${prefix}/DmPortal/equipmentdetail/${this.currentScopeView}/${type}/${technicalId}/timeline`;
    },
    exportExcelPairing() {
      const filter =
        this.latestDataPairingState !== null &&
          this.latestDataPairingState !== undefined
          ? this.latestDataPairingState.filterDefinition
          : "";
      let exportUrl = `${this.exportPairingRoot}cultureName=${this.$i18n.locale}&exporFormat=excel&deviceId=${this.deviceId}`;
      if (filter != "") {
        exportUrl = `${this.exportPairingRoot}cultureName=${this.$i18n.locale}&filter=${filter}&exporFormat=excel&deviceId=${this.deviceId}`;
      }

      this.mainService
        .Export(exportUrl, this.gridHeaders)
        .then((response) => {
          console.log(response);
          const type = response.headers["content-type"];
          utils.DownloadBytes(
            `${this.$t("pages.DeviceDetails.Title")}_${this.$t("pages.DeviceDetails.PairingHistory.ExportName")}(${this.ExternalId
            })`,
            type,
            "xlsx",
            response.data
          );
        })
        .catch((error) => {
          console.log(error);
        });
    },
    exportCsvPairing() {
      const filter =
        this.latestDataPairingState !== null &&
          this.latestDataPairingState !== undefined
          ? this.latestDataPairingState.filterDefinition
          : "";
      let exportUrl = `${this.exportPairingRoot}cultureName=${this.$i18n.locale}&exporFormat=csv&deviceId=${this.deviceId}`;
      if (filter != "") {
        exportUrl = `${this.exportPairingRoot}cultureName=${this.$i18n.locale}&filter=${filter}&exporFormat=csv&deviceId=${this.deviceId}`;
      }

      this.mainService
        .Export(exportUrl, this.gridHeaders)
        .then((response) => {
          console.log(response);
          const type = response.headers["content-type"];
          utils.DownloadBytes(
            `${this.$t("pages.DeviceDetails.Title")}_${this.$t("pages.DeviceDetails.PairingHistory.ExportName")}(${this.ExternalId
            })`,
            type,
            "csv",
            response.data
          );
        })
        .catch((error) => {
          console.log(error);
        });
    },
    gridPairingInitialized(flexgrid) {
      this.theGrid = flexgrid;
    },
    exportCsvAssociation() {
      const filter =
        this.latestDataAssociationState !== null &&
          this.latestDataAssociationState !== undefined
          ? this.latestDataAssociationState.filterDefinition
          : "";
      let exportUrl = `${this.exportAssociationRoot}cultureName=${this.$i18n.locale}&exporFormat=csv&deviceId=${this.deviceId}&type=${this.DeviceType}`;
      if (filter != "") {
        exportUrl = `${this.exportAssociationRoot}cultureName=${this.$i18n.locale}&filter=${filter}&exporFormat=csv&deviceId=${this.deviceId}&type=${this.DeviceType}`;
      }

      this.mainService
        .Export(exportUrl, this.gridHeaders)
        .then((response) => {
          console.log(response);
          const type = response.headers["content-type"];
          utils.DownloadBytes(
            `${this.$t("pages.DeviceDetails.Title")}_${this.$t("pages.DeviceDetails.AssociationHistory.ExportName")}(${this.ExternalId
            })`,
            type,
            "csv",
            response.data
          );
        })
        .catch((error) => {
          console.log(error);
        });
    },
    exportExcelAssociation() {
      const filter =
        this.latestDataAssociationState !== null &&
          this.latestDataAssociationState !== undefined
          ? this.latestDataAssociationState.filterDefinition
          : "";
      let exportUrl = `${this.exportAssociationRoot}cultureName=${this.$i18n.locale}&exporFormat=excel&deviceId=${this.deviceId}&type=${this.DeviceType}`;
      if (filter != "") {
        exportUrl = `${this.exportAssociationRoot}cultureName=${this.$i18n.locale}&filter=${filter}&exporFormat=excel&deviceId=${this.deviceId}&type=${this.DeviceType}`;
      }

      this.mainService
        .Export(exportUrl, this.gridHeaders)
        .then((response) => {
          console.log(response);
          const type = response.headers["content-type"];
          utils.DownloadBytes(
            `${this.$t("pages.DeviceDetails.Title")}_${this.$t("pages.DeviceDetails.AssociationHistory.ExportName")}(${this.ExternalId
            })`,
            type,
            "xlsx",
            response.data
          );
        })
        .catch((error) => {
          console.log(error);
        });
    },
    exportCsvUnclassifiedParameters() {
      var xls = new XlsExport(this.data.Data);
      xls.exportToCSV(
        `${this.$t("pages.DeviceDetails.UnclassifiedParameters.Title")}(${this.ExternalId
        })`
      );
    },
    exportExcelUnclassifiedParameters() {
      var xls = new XlsExport(this.data.Data);
      xls.exportToXLS(
        `${this.$t("pages.DeviceDetails.UnclassifiedParameters.Title")}(${this.ExternalId
        })`
      );
    },
    formatColumnsAssociation: function (s, e) {
      const flex = s;
      if (e.panel == flex.cells) {
        if (flex.rows[e.row].dataItem.name) return;
        const translatedText = this.translationExists("pages.DeviceDetails.DeviceSources." + s.rows[e.row].dataItem.Source)
          ?
          this.$t(
            "pages.DeviceDetails.DeviceSources." + s.rows[e.row].dataItem.Source
          ) : s.rows[e.row].dataItem.Source;

        switch (flex.columns[e.col].header) {
          case "Source":
            e.cell.innerHTML = s.rows[e.row].dataItem.Source
              ? translatedText.includes(".")
                ? s.rows[e.row].dataItem.Source
                : translatedText
              : "";
            break;
        }
      }
    },
    formatColumnsPairing: function (s, e) {
      const flex = s;

      if (e.panel == flex.cells) {
        //Bug: Wijmo re-drow the grid when grouping rows which cause a bug since that it sends a GroupRow to the formatting
        //method instead of Row object. 1- The GroupRow does not contain row data. 2- No need to re-drow the table (what a waste)
        if (flex.rows[e.row].dataItem.name) return;

        switch (flex.columns[e.col].header) {
          case "Actions":
            e.cell.innerHTML =
              Globalize.format(
                '<i class="scf-checkBox-on" style="margin-left: 7px;margin - right: 7px;width: 16px;height: 16px;" title="" ></i>',
                s.rows[e.row].dataItem
              ) +
              Globalize.format(
                '<i class="scf-checkBox-off" style="margin-left: 7px;margin - right: 7px;width: 16px;height: 16px;" title="" ></i>',
                s.rows[e.row].dataItem
              );

            break;
        }

        switch (flex.columns[e.col].binding) {
          case "graph":
            e.cell.innerHTML =
              wijmo.format(
                '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" style="margin-left:10px" class="bi bi-trash" viewBox="0 0 16 16"><path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/><path fill-rule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/></svg>',
                s.rows[e.row].dataItem
              ) +
              wijmo.format(
                '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" style="margin-left:10px" class="bi bi-arrow-repeat" viewBox="0 0 16 16"><path d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41zm-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9z"/><path fill-rule="evenodd" d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5.002 5.002 0 0 0 8 3zM3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9H3.1z"/></svg>',
                s.rows[e.row].dataItem
              );

            break;
          case "MountingDate":
            e.cell.innerText =
              s.rows[e.row].dataItem.MountingDate != null
                ? this.$d(s.rows[e.row].dataItem.MountingDate, {
                  year: "numeric",
                  month: "2-digit",
                  day: "2-digit",
                  hour: "2-digit",
                  minute: "2-digit",
                  second: "2-digit",
                })
                : "";
            break;
          case "FirmwareDescription":
            e.cell.innerHTML = wijmo.format(
              '<a href="#">Link</a>',
              s.rows[e.row].dataItem
            );
            break;
        }
      }
    },
    getTraductionState: function (e) {
      return this.tryGetTranslation(`pages.FirmwareList.State.${e}`);
    },
    tryGetTranslation(key) {
      return typeof this.$tm(key) == "string"
        ? this.$t(key)
        : key;
    },
    initCountRowsPopup(popup) {
      this.countRowsPopup = popup;
    },
    countRows(popup) {
      this.showCountRowsMessage = this.data.Data.length;
      popup.show(true, () => { });
    },
    exportCsv(event) {
      console.log(event);
      console.log("Csv");
    },
    exportExcel(event) {
      console.log(event);
      console.log("Excel");
    },
    formatColumns(s, e) {
      const flex = s;

      if (e.panel == flex.cells) {
        switch (flex.columns[e.col].binding) {
          case "Actions":
            e.cell.innerHTML =
              Globalize.format(
                '<i class="scf-checkBox-on" style="margin-left: 7px;margin - right: 7px;width: 16px;height: 16px;" title="" ></i>',
                s.rows[e.row].dataItem
              ) +
              Globalize.format(
                '<i class="scf-checkBox-off" style="margin-left: 7px;margin - right: 7px;width: 16px;height: 16px;" title="" ></i>',
                s.rows[e.row].dataItem
              );
            break;
        }
      }
    },
    getTraductionTransactionSource: function (e) {
      return this.tryGetTranslation(`pages.DeviceImportList.Source.${e}`);
    },
    map(t) {
      return Object.entries(t).map((el) => {
        return {
          Key: el[0],
          Value: el[1],
        };
      });
    },
    GetCardDetails(t) {
      return Object.entries(t).map((el) => {
        return {
          key: this.translationExists("pages.DeviceDetails." + el[0]) ? this.$t("pages.DeviceDetails." + el[0]) : el[0],
          value: el[1],
        };
      });
    },
    GetKeysValuesArray(t) {
      return Object.entries(t).map((el) => {
        return {
          key: el[0],
          value: el[1],
        };
      });
    },
    GetSourceDictionnary(t) {
      return Object.entries(t).map((el) => {
        return {
          key: el[1].parameterName,
          value: el[1].transactionSourceEnum,
        };
      });
    },
    GetSourceParamDictionnary(t) {
      return Object.entries(t).map((el) => {
        return {
          key: el[1].parameterName,
          Value: el[1].transactionSourceEnum,
        };
      });
    },
    GetIconByFunctionalSection(sectionKey) {
      if (
        typeof this.FunctionalSectionIcons.filter(
          (e) => e.Key == sectionKey
        )[0] !== "undefined"
      ) {
        return this.FunctionalSectionIcons.filter((e) => e.Key == sectionKey)[0]
          .Value;
      }
      return "";
    },
    GetColorBySource(source) {
      if (
        typeof this.SourcesColor.filter((e) => e.Key == source)[0] !==
        "undefined"
      ) {
        return this.SourcesColor.filter((e) => e.Key == source)[0].Value;
      }
      return "";
    },
    GetCustomDetails(t) {
      return Object.entries(t).map((el) => {
        return {
          key: el[1].key,
          value: el[1].Value,
          Source: el[1].Source,
          ReadOnly: el[1].isReadonly,
          AllowedValues:
            el[1].allowedValues != null
              ? this.CreateArrayKeyValuesFromString(
                el[1].allowedValues.split("|")
              )
              : null,
          Traductions: el[1].translations,
        };
      });
    },
    CreateArrayKeyValuesFromString(array) {
      let list = [];
      array.forEach((x) =>
        list.push({ value: x, name: this.GetParametersTraductionValue(x) })
      );
      return list;
    },

    mapEntries(p, e) {
      if (typeof p.filter((r) => r.key == e.key)[0] !== "undefined") {
        return p.filter((r) => r.key == e.key)[0].value;
      }
      return null;
    },
    mapEntriesSources(p, e) {
      if (typeof p.filter((r) => r.key == e.key)[0] !== "undefined") {
        return p.filter((r) => r.key == e.key)[0].value;
      }
      return "";
    },
    translationExists(e) {
      return typeof this.$tm(e) == "string";
    },
    GetParametersTraductionValue(value) {

      if (this.translationExists("pages.DeviceDetails.ParametersValues." + value))
        return this.$t("pages.DeviceDetails.ParametersValues." + value);
      return value;
    },
    GenerateTransactionValuesMessage(deviceParameterTransactionValue) {

      if (this.translationExists("pages.DeviceDetails." + deviceParameterTransactionValue.parameterName)) {
        if (deviceParameterTransactionValue.oldValue == null) {
          return `${this.$t(
            "pages.DeviceDetails." +
            deviceParameterTransactionValue.parameterName
          )}  ${this.$t("pages.DeviceDetails.TimeLine.SetTo")} ${deviceParameterTransactionValue.newValue
            }`;
        }
        return `${this.$t(
          "pages.DeviceDetails." + deviceParameterTransactionValue.parameterName
        )}${this.$t("pages.DeviceDetails.TimeLine.UpdatedFrom")} ${deviceParameterTransactionValue.oldValue
          } ${this.$t("pages.DeviceDetails.TimeLine.To")} ${deviceParameterTransactionValue.newValue
          } `;
      }
    },
    sort_by(field, reverse, primer) {
      const key = primer
        ? function (x) {
          return primer(x[field]);
        }
        : function (x) {
          return x[field];
        };

      reverse = !reverse ? 1 : -1;

      return function (a, b) {
        return (a = key(a)), (b = key(b)), reverse * ((a > b) - (b > a));
      };
    },
    CastUtcToLocalTimeByKey(list, paramKey) {
      let param = list.filter((e) => e.key == paramKey)[0];
      if (param != undefined) {
        if (param.value != null)
          param.value = new Date(param.value).toLocaleString();
      }
    },
    GenerateCards(sourceParams, params, datamodel, index, lifeCycle) {
      var listcard = [];

      for (const FunctionalSection of datamodel.functionalSections) {
        let cardmodel = new CardModel();

        // recuperer la SectionKey (nom de la carte) et chercher les params
        //   console.log(FunctionalSection.sectionKey);
        var t = datamodel.deviceParameterDefinitions.filter(
          (e) => e.functionalSectionKey == FunctionalSection.sectionKey
        );

        if (
          typeof datamodel.deviceDisplayFieldsDefinitions !== "undefined" &&
          datamodel.deviceDisplayFieldsDefinitions !== null
        ) {
          datamodel.deviceDisplayFieldsDefinitions.forEach((e) => {
            e.key = e.fieldKey;
            e.Value = this.getMainCardTitle(e.fieldExpression, params);
          });
          t = datamodel.deviceParameterDefinitions
            .concat(datamodel.deviceDisplayFieldsDefinitions)
            .filter(
              (e) => e.functionalSectionKey == FunctionalSection.sectionKey
            );
        }

        t.forEach((e) => {
          e.Value = this.mapEntries(params, e); // p.filter(r=>r.key==e.Key)[0];
        });

        //  var ttt = new AnotherEquipment() ;

        cardmodel.Key = FunctionalSection.sectionKey;
        cardmodel.DataModel = datamodel;
        cardmodel.Translations = FunctionalSection.translations;
        cardmodel.Index = index + FunctionalSection.sectionIndex;
        cardmodel.Icon = this.GetIconByFunctionalSection(
          FunctionalSection.sectionKey
        );

        cardmodel.Parameters = t.sort(
          this.sort_by("FunctionalFieldlIndex", false, parseInt)
        );
        cardmodel.Parameters.forEach((e) => {
          //e.Source = "Manufacturer";
          e.Source = this.mapEntriesSources(sourceParams, e);
          // if (typeof sourceParams !== "undefined") {
          //   e.Source = this.mapEntriesSources(sourceParams, e); //   dictionnaryDeviceParamsSources.filter((s) => s.key == e.key)[0].value;
          // } else {
          //   e.Source = "Manufacturer";
          // }
        });

        if (cardmodel.Key == "LifeCycleInfos") {
          let tmp = new Object();
          tmp.key = "LifeCycle";

          tmp.Value = this.GetLifeCycleTraductions(
            lifeCycle,
            datamodel
          );
          tmp.translations = this.LifeCycleLabelTraductions;
          cardmodel.Parameters.push(tmp);
          cardmodel.Parameters.forEach((e) => {
            e.isReadonly = true;
            e.isRequired = false;
          });

          cardmodel.Parameters = this.ValidateLifeCycleValues(
            cardmodel.Parameters,
            datamodel,
            params
          );
        }
        listcard.push(cardmodel);
      }
      return listcard;
    },

    GetLifeCycleTraductions(lifecycle, dataModel) {
      let traduction = lifecycle;
      var x = dataModel.lifeCycle.states.filter((e) => e.name == lifecycle);
      if (!utils.isEmpty(x)) {
        // var traductions = x[0].translations;

        // if (!utils.isEmpty(traductions)) {
        //   let trad;
        //   trad = traductions.filter((e) => e.culture == culture);
        //   if (!utils.isEmpty(trad)) {
        //     traduction = trad[0].value;
        //   }
        // }
      }

      return traduction;
    },
    IsSensorAttachedToAG3BIRDZ(dataModel, deviceParams) {
      if (dataModel.deviceType == "Sensor") {
        const transmitter2Gor1Gidentifier = deviceParams.filter(dp => dp.key == "TransmitterModule1GIdentifier" || dp.key == "TransmitterModule2GIdentifier");
        const transmitterLoraOrG3BIRDZidentifier = deviceParams.filter(dp => dp.key == "TransmitterIdentifier");

        return transmitter2Gor1Gidentifier.length == 0 && transmitterLoraOrG3BIRDZidentifier.length > 0;
      }
      return false;
    },
    ValidateLifeCycleValues(params, dataModel, allParams) {
      var newParams = [];
      var AlternatifKeyHasBeenUsed = [];

      // un compteur lié à un LORA/G3BIRDZ
      if (this.IsSensorAttachedToAG3BIRDZ(dataModel, allParams)) {
        params = params.filter(p => p.key !== "TransmitterModule2GIdentifier" && p.key !== "TransmitterModule1GIdentifier");
      } else {
        params = params.filter(p => p.key !== "TransmitterIdentifier");
      }

      // var ignoredparams = dataModel.deviceDisplayFieldsDefinitions.filter((e)=>e.alternatifKey!=null);
      var paramsOrdered = params.sort(
        this.sort_by("alternatifKey", false, (a) => a)
      );
      for (let i = 0; i < paramsOrdered.length; i++) {
        if (AlternatifKeyHasBeenUsed.some((x) => x == paramsOrdered[i].key))
          continue;

        if (paramsOrdered[i].Value == null) {
          if (paramsOrdered[i].alternatifKey != null) {
            if (!utils.isEmpty(allParams.filter(
              (r) => r.key == paramsOrdered[i].alternatifKey
            ))) {
              paramsOrdered[i].Value = allParams.filter(
                (r) => r.key == paramsOrdered[i].alternatifKey
              )[0].value;
              AlternatifKeyHasBeenUsed.push(paramsOrdered[i].alternatifKey);
            }
          }
        }

        newParams.push(paramsOrdered[i]);
      }

      return newParams;
    },
    getMainCardTitle(expression, params) {
      while (expression.includes("{")) {
        var s = expression.substring(
          expression.indexOf("{") + 1,
          expression.indexOf("}")
        );
        var p = params.filter((e) => e.key === s);
        console.log(p);

        if (p.length > 0) {
          expression = expression.replace(
            "{".concat(s).concat("}"),
            p[0].value
          );
        } else {
          expression = expression.replace("{".concat(s).concat("}"), "N/A");
        }
      }
      return expression;
    },
    sortFunction(a, b) {
      var dateA = new Date(a.CreatedDate).getTime();
      var dateB = new Date(b.CreatedDate).getTime();
      return dateA < dateB ? 1 : -1;
    },
    GetParameterTraductionForTitleAdditionalCard(value) {
      var traduction = "";
      let x = this.DataModel.additionalSections.filter(
        (e) => e.sectionKey == value
      );
      if (!utils.isEmpty(x)) {
        let trad;
        trad = x[0].translations.filter((e) => e.culture == this.culture);
        if (!utils.isEmpty(trad)) {
          traduction = trad[0].value;
        } else {
          traduction = value;
        }
      }
      return traduction;
    },
    ExistingElement(obj, list) {
      var i;
      for (i = 0; i < list.length; i++) {
        // console.log(
        //   "🚀 ~ file: EquipmentDetail.vue: listAnotherEquipment obj",
        //   obj
        // );
        if (list[i].Id === obj.Id) {
          return true;
        }
      }

      return false;
    },
    async initPage() {
      //* get params (deviceId) from previous page (basically EquipementList.vue )
      var deviceId = this.$route.params.externalId;
      var deviceType = this.$route.params.deviceType;

      //  baseDeviceType = this.$route.params.externalId;

      //* get further information about device based on deviceId
      var device = await this.mainService.getdevicesById(deviceId, this.gridHeaders);

      //var lifeCycle = device.lifeCycle;
      ///* using api

      //* fetch DataModel for the principal device based on deviceId
      const deviceModelInfo = await this.mainService.getDataModel(deviceId, this.gridHeaders);

      //* same things as dataModel but here we fetch parameters
      let deviceParams = await this.mainService.getEquipmentDetails(deviceId, this.gridHeaders);

      if (device.type === "Asset") {
        this.additionalData = this.GetKeysValuesArray(deviceParams);
      }

      //* retreive Source of parameters
      const deviceParamsSource = await this.mainService.getParametersSources(
        deviceId,
        deviceType,
        this.gridHeaders
      );

      this.DataModel = deviceModelInfo;
      this.PreAssembly = deviceParams;
      this.ExternalId = device.externalId;
      this.deviceId = deviceId;
      this.DeviceType = device.type;

      var dictionnaryDeviceParamsSources =
        this.GetSourceDictionnary(deviceParamsSource);

      var p = this.GetKeysValuesArray(deviceParams);

      //* generate title card based on cardTitleExpression in dataModel (else : it mapped directly as TYPE EXTERNALID)
      //#region Generate title main card based in cardTitleExpression section datamodel if exist what else (TYPE EXTERNALID ) expression was basically applied
      if (deviceModelInfo.cardTitleExpression != null) {
        let tmp = this.getMainCardTitle(deviceModelInfo.cardTitleExpression, p);
        this.MainCardTitle = tmp.includes("{") ? null : tmp;
      }
      //#endregion
      var listcard = [];

      deviceModelInfo.deviceParameterDefinitions.forEach((e) => {
        e.Value = this.mapEntries(p, e);

        if (
          typeof e.isAnotherDevice !== "undefined" &&
          e.isAnotherDevice != null
        ) {
          //!TODO filtrer sur la liste des devices par externalId et récuperer l'id

          this.mainService
            .getdevicesByExternalId(e.Value)
            .then((data) => {
              console.log(
                "🚀 ~ file: EquipmentDetail.vue:1637 ~ .then ~ response.data",
                data
              );
              if (data) {
                let anotherEquipment = new AnotherEquipment();
                anotherEquipment.Key = e.key;
                anotherEquipment.Value = e.Value;
                anotherEquipment.Type = data.type;
                anotherEquipment.SubType = data.subType;
                anotherEquipment.Id = data.id;
                anotherEquipment.LifeCycle = data.lifeCycle;

                if (anotherEquipment.Id) {
                  this.mainService
                    .getDataModel(anotherEquipment.Id)
                    .then((response) => {
                      if (response.additionalSections.length > 0) {
                        let hasUnclassifiedParameters =
                          response.additionalSections.find(
                            (e) => e.sectionKey === "UnclassifiedParameters"
                          );
                        if (hasUnclassifiedParameters)
                          anotherEquipment.hasUnclassifiedParameters = true;
                        else anotherEquipment.hasUnclassifiedParameters = false;
                      }
                      anotherEquipment.DataModel = response;
                      if (
                        response.additionalSections.filter(
                          (e) => e.sectionKey === "PairingHistory"
                        ).length > 0
                      ) {
                        anotherEquipment.hasPairingHistory = true;
                      } else {
                        anotherEquipment.hasPairingHistory = false;
                      }

                      if (
                        response.additionalSections.filter(
                          (e) => e.sectionKey === "AssociationHistory"
                        ).length > 0
                      ) {
                        anotherEquipment.hasAssociationHistory = true;
                      } else {
                        anotherEquipment.hasAssociationHistory = false;
                      }

                      // if (
                      //   response.additionalSections.filter(
                      //     (e) => e.sectionKey === "LifeCycleInfos"
                      //   ).length > 0
                      // ) {
                      //   anotherEquipment.hasLifeCycleInfos = true;
                      // } else {
                      //   anotherEquipment.hasLifeCycleInfos = false;
                      // }

                      this.mainService
                        .getEquipmentDetails(anotherEquipment.Id)
                        .then((responseParams) => {
                          console.log(responseParams);

                          var paramsTranslate =
                            this.GetKeysValuesArray(responseParams);

                          if (anotherEquipment.Type === "Asset") {
                            this.additionalData = paramsTranslate;
                          }

                          if (response.cardTitleExpression != null) {
                            var secondtitle = this.getMainCardTitle(
                              response.cardTitleExpression,
                              paramsTranslate
                            );

                            anotherEquipment.Title = secondtitle.includes("{")
                              ? anotherEquipment.Value
                              : secondtitle;
                          } else {
                            anotherEquipment.Title = anotherEquipment.Value;
                          }

                          this.mainService
                            .getParametersSources(
                              anotherEquipment.Id,
                              anotherEquipment.Type
                            )
                            .then((r) => {
                              let sources = this.GetSourceDictionnary(r);
                              anotherEquipment.Cards = this.GenerateCards(
                                sources,
                                paramsTranslate,
                                response,
                                this.IndexAnotherDeviceCards,
                                anotherEquipment.LifeCycle
                              );
                              this.IndexAnotherDeviceCards += 50;
                              if (
                                this.listAnotherEquipment.filter(
                                  (e) => e.Id == anotherEquipment.Id
                                ).length == 0
                              ) {
                                // if (anotherEquipment.hasLifeCycleInfos == true)
                                //   anotherEquipment.LifeCycleInfosCard = this.GenerateLifeCycleInfosCard(anotherEquipment.SubType, paramsTranslate, sources, anotherEquipment.Cards.length, anotherEquipment.LifeCycle,response.additionalSections);
                                // console.log("🚀 ~ file: EquipmentDetail.vue:2202 ~ .then ~ paramsTranslate:", paramsTranslate);
                                // console.log("🚀 ~ file: EquipmentDetail.vue:2202 ~ .then ~ sources:", sources);
                                // console.log("🚀 ~ file: EquipmentDetail.vue:2202 ~ .then ~ anotherEquipment.LifeCycleInfosCard:", anotherEquipment.LifeCycleInfosCard);

                                this.listAnotherEquipment.push(
                                  anotherEquipment
                                );
                                console.log(
                                  "🚀 ~ file: EquipmentDetail.vue:1968 ~ .then ~ anotherEquipment:",
                                  anotherEquipment
                                );
                                this.IsAnotherDevices =
                                  this.listAnotherEquipment;
                              }
                            })
                            .catch((e) => console.error(e));
                        })
                        .catch((error) => {
                          console.error(error);
                        });
                    })
                    .catch((error) => {
                      console.error(error);
                    });
                }
              }
            })
            .catch((error) => {
              console.log(error);
            })
            .finally(() => { });
        }
      });

      for (const FunctionalSection of deviceModelInfo.functionalSections) {
        let cardmodel = new CardModel();

        var t = deviceModelInfo.deviceParameterDefinitions.filter(
          (e) => e.functionalSectionKey == FunctionalSection.sectionKey
        );
        if (
          typeof deviceModelInfo.deviceDisplayFieldsDefinitions !==
          "undefined" &&
          deviceModelInfo.deviceDisplayFieldsDefinitions !== null
        ) {
          //* Generate Title for Specific Section attribute based on expression value
          /*
              Value: "11A5221862871007, 51522F89"
              fieldExpression: "{TransmitterModule2GIdentifier}, {TransmitterModule1GIdentifier}"
              fieldKey: "TransmitterIdentifier"
              functionalFieldlIndex: 1
              functionalSectionKey: "Pairing"
              key:"TransmitterIdentifier"
              */
          deviceModelInfo.deviceDisplayFieldsDefinitions.forEach((e) => {
            e.key = e.fieldKey;
            e.Value = this.getMainCardTitle(e.fieldExpression, p);
          });

          t = deviceModelInfo.deviceParameterDefinitions
            .concat(deviceModelInfo.deviceDisplayFieldsDefinitions)
            .filter(
              (e) => e.functionalSectionKey == FunctionalSection.sectionKey
            );
        }
        cardmodel.Type = deviceModelInfo.deviceSubtype;
        cardmodel.DataModel = deviceModelInfo;
        cardmodel.Key = FunctionalSection.sectionKey;
        cardmodel.Index = FunctionalSection.sectionIndex;
        cardmodel.Translations = FunctionalSection.translations;
        cardmodel.Icon = this.GetIconByFunctionalSection(
          FunctionalSection.sectionKey
        );
        cardmodel.Parameters = t.sort(
          this.sort_by("functionalFieldlIndex", false, parseInt)
        );

        cardmodel.Parameters.forEach((e) => {
          e.Source = this.mapEntriesSources(dictionnaryDeviceParamsSources, e); //   dictionnaryDeviceParamsSources.filter((s) => s.key == e.key)[0].value;
        });

        if (cardmodel.Key == "LifeCycleInfos") {
          let tmp = new Object();
          tmp.key = "LifeCycle";

          tmp.Value = this.GetLifeCycleTraductions(
            device.lifeCycle,
            this.DataModel
          );
          tmp.translations = this.LifeCycleLabelTraductions;
          cardmodel.Parameters.push(tmp);
          cardmodel.Parameters.forEach((e) => {
            e.isReadonly = true;
            e.isRequired = false;
          });

          cardmodel.Parameters = this.ValidateLifeCycleValues(
            cardmodel.Parameters,
            this.DataModel,
            p
          );

          console.log(
            "🚀 ~ file: EquipmentDetail.vue:2328 ~ deviceModelInfo.deviceParameterDefinitions.forEach ~ cardmodel:",
            cardmodel
          );
        }
        listcard.push(cardmodel);
      }

      //listcard.push(this.GenerateLifeCycleInfosCard(deviceModelInfo.deviceSubtype,p,deviceParamsSource,listcard.length));

      // this.LifeCycleInfosCard = this.GenerateLifeCycleInfosCard(deviceModelInfo.deviceSubtype, p, deviceParamsSource, listcard.length, lifeCycle,deviceModelInfo.additionalSections);

      // console.log("🚀 ~ file: EquipmentDetail.vue:2024 ~ deviceModelInfo.deviceParameterDefinitions.forEach ~ LifeCycleInfosCard:", this.LifeCycleInfosCard);

      this.CardData = listcard;
      console.log(
        "🚀 ~ file: EquipmentDetail.vue:2267 ~ deviceModelInfo.deviceParameterDefinitions.forEach ~ CardData:",
        this.CardData
      );

      if (
        deviceModelInfo.additionalSections.filter(
          (e) => e.sectionKey === "UnclassifiedParameters"
        ).length > 0
      ) {
        this.UnclassifiedParameters = true;
      }
      if (
        deviceModelInfo.additionalSections.filter(
          (e) => e.sectionKey === "PairingHistory"
        ).length > 0
      ) {
        this.PairingHistory = true;
      }

      if (
        deviceModelInfo.additionalSections.filter(
          (e) => e.sectionKey === "AssociationHistory"
        ).length > 0
      ) {
        this.AssociationHistory = true;
      }

      // if (
      //   deviceModelInfo.additionalSections.filter(
      //     (e) => e.sectionKey === "LifeCycleInfos"
      //   ).length > 0
      // ) {
      //   this.hasLifeCycleInfos = true;
      // }

      this.mainService
        .getDeviceTransactions(this.deviceId)
        .then((response) => {
          if (response != undefined) {
            this.transactions = response;
            for (const item of this.transactions) {
              let transaction = new Transaction();
              let transactionValuesMessage = [];
              let errors = [];
              transaction.Source = item.sourceEnum;
              transaction.Color = this.GetColorBySource(item.sourceEnum);
              transaction.CreatedDate = item.createdDate;
              transaction.Status = item.statusEnum;
              transaction.TransactionSource = item.importExternalId;
              transaction.createdUser = item.createdUser;
              transaction.DeviceImportId = item.deviceImportId;
              transaction.DataModel = this.DataModel;
              console.log(
                "🚀 ~ file: EquipmentDetail.vue:2359 ~ .then ~ DataModel:",
                typeof DataModel
              );

              transaction.DeviceParameterTransactionValues =
                item.deviceParameterTransactionValues;
              if (transaction.Status == "KO") {
                transaction.Color = "red";
                this.mainService
                  .GetdeviceImportReportByExternalId(
                    transaction.DeviceImportId,
                    this.ExternalId
                  )
                  .then((response) => {
                    if (response.value != undefined) {
                      response.value.forEach((e) => {
                        const errorToPush = this.GetMessageError(
                          e.ErrorCode,
                          e.ErrorMessageValues,
                          this.errorMessages
                        );
                        errors.push(errorToPush);
                      });
                      return errors;
                    }
                  })
                  .then((errors) => {
                    transaction.ErrorMessages = errors;
                    transaction.DeviceParameterTransactionValues.forEach(
                      (e) => {
                        transactionValuesMessage.push(
                          this.GenerateTransactionValuesMessage(e)
                        );
                      }
                    );

                    transaction.TransactionValuesMessages =
                      transactionValuesMessage;
                    this.preloadedTransactionItems.push(transaction);
                    this.treatedTransactions += 1;
                    this.loadedTimeLine = true;
                  })
                  .catch((error) => {
                    console.error(error);
                    Swal.fire(this.$t("pages.FirmwareAdd.ErrorLabel.Error"));
                  });
              } else {
                //Pas besoin de fetcher les traductions d'erreurs tantque y pas d'erreur et l'import est ok
                transaction.ErrorMessages = [];
                transaction.DeviceParameterTransactionValues.forEach((e) => {
                  transactionValuesMessage.push(
                    this.GenerateTransactionValuesMessage(e)
                  );
                });

                transaction.TransactionValuesMessages =
                  transactionValuesMessage;
                this.preloadedTransactionItems.push(transaction);
                console.log(
                  "🚀 ~ file: EquipmentDetail.vue:2406 ~ .then ~ transaction:",
                  transaction
                );
                this.treatedTransactions += 1;
                this.loadedTimeLine = true;
              }
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    refreshContent(newScopeVal) {
      if (newScopeVal && this.componentKey < 1) {
        this.mainService = new MainService(this.$jwt.token, newScopeVal);
        this.initPage();
        this.componentKey += 1;
      }
    }
  },
  async beforeMount() {
    this.targetTab = this.$route.params.target;
  },
  async mounted() {
    let errorsMessages = await this.mainService.getMessageErrorCode(
      this.culture
    );
    this.errorMessages = this.GetKeysValuesArray(errorsMessages);
    const e = new CustomEvent("component-ready");
    window.dispatchEvent(e);
    if (this.currentScope) {
      this.refreshContent(this.currentScope);
    }
  },
});
</script>

<style lang="scss" scoped>
.wj-control.wj-content.wj-flexgrid.wj-state-readonly {
  height: 20vh !important;
}

#about-page {
  font-family: "D-DIN" !important;
}

.mt-70 {
  margin-top: 70px;
}

.mb-70 {
  margin-bottom: 70px;
}

.card-timeline {
  border-width: 0;
  transition: all 0.2s;
}

.card-timeline {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
}

.card-body {
  font-family: D-DIN !important;
  flex: 1 1 auto;
  padding: 1.25rem;
}

.vertical-timeline {
  width: 100%;
  position: relative;
  padding: 1.5rem 0 1rem;
}

.vertical-timeline::before {
  content: "";
  position: absolute;
  top: 0;
  left: 67px;
  height: 100%;
  width: 4px;
  background: #e9ecef;
  border-radius: 0.25rem;
}

.vertical-timeline-element {
  position: relative;
  margin: 0 0 1rem;
}

.vertical-timeline--animate .vertical-timeline-element-icon.bounce-in {
  visibility: visible;
  animation: cd-bounce-1 0.8s;
}

.vertical-timeline-element-icon {
  position: absolute;
  top: 0;
  left: 60px;
}

.vertical-timeline-element-icon .badge-dot-xl {
  box-shadow: 0 0 0 5px #fff;
}

.badge-dot-xl {
  width: 18px;
  height: 18px;
  position: relative;
}

.badge:empty {
  display: none;
}

.badge-dot-xl::before {
  content: "";
  width: 10px;
  height: 10px;
  border-radius: 0.25rem;
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -5px 0 0 -5px;
  background: #fff;
}

.vertical-timeline-element-content {
  font-family: D-DIN !important;
  position: relative;
  margin-left: 90px;
  font-size: 0.8rem;
}

.vertical-timeline-element-content .timeline-title {
  font-family: D-DIN !important;
  font-size: 0.8rem;
  text-transform: uppercase;
  margin: 0 0 0.5rem;
  padding: 2px 0 0;
  font-weight: bold;
}

.vertical-timeline-element-content .vertical-timeline-element-date {
  font-family: D-DIN !important;
  display: block;
  position: absolute;
  left: -90px;
  top: 0;
  padding-right: 10px;
  text-align: right;
  color: #adb5bd;
  font-size: 0.7619rem;
  white-space: nowrap;
}

.vertical-timeline-element-content:after {
  content: "";
  display: table;
  clear: both;
}

.vertical-timeline-element-icon .badge-dot-xl {
  box-shadow: 0 0 0 5px #fff;
}

.badge-dot-xl {
  width: 18px;
  height: 18px;
  position: relative;
}

.badge-warning {
  color: #212529;
  background-color: #ffc107;
}

.badge {
  font-family: D-DIN !important;
  display: inline-block;
  padding: 0.25em 0.4em;
  font-size: 75%;
  font-weight: 700;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.card {
  font-family: D-DIN !important;
  border: 1px solid #030f40 !important;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
}

.card_header {
  font-family: D-DIN-500 !important;
  padding: 0.5rem 1rem;
  margin-bottom: 0;
  border-radius: 10px 10px 0px 0px !important;
  border-bottom: 1px solid #030f40 !important;
}

.card-header {
  font-family: D-DIN !important;
  margin-bottom: 0px;
  border-radius: 10px 10px 0px 0px !important;
  background-color: #bbdbfd !important;
}

#maincard,
#maincard-header {
  border-bottom: 0px;
  font-family: D-DIN !important;
  background-color: #f4f6fb !important;
}

.card-header.collapsed {
  .rotateicon {
    transform: rotate(90deg);
    transition: 0.3s transform ease-in-out;
  }

  border-radius: 10px 10px 10px 10px !important;
}

.card-header:not(.collapsed) {
  .rotateicon {
    transition: 0.3s transform ease-in-out;
  }

  border-radius: 0px 10px 0px 0px !important;
}

.nav-fill .nav-item .nav-link,
.nav-justified .nav-item .nav-link {
  width: auto;
}

.nav-tabs .nav-item.show .nav-link,
.nav-tabs .nav-link.active {
  color: #1266f1;
  border-color: #1266f1;
}

.nav-tabs .nav-item.show .nav-link,
.nav-tabs .nav-link.active {
  color: #1266f1;
  background-color: #fff;
  border-color: #1266f1 #1266f1 #1266f1;
}

.nav-tabs .nav-link {
  font-family: D-DIN !important;
  border: solid transparent;
  border-width: 0 0 2px;
  border-radius: 0;
  text-transform: uppercase;
  line-height: 1;
  font-weight: 500;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.6);
  padding: 17px 29px 16px;
}

.nav-link {
  display: block;
  padding: 0.5rem 1rem;
  color: #1266f1;
  text-decoration: none;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out;
}

a:hover {
  color: #0e52c1;
}

.nav-link:focus,
.nav-link:hover {
  color: #0e52c1;
}

.title-col-card {
  font-family: D-DIN-700 !important;
  font-style: normal !important;
  color: #6095d6;
}

.transmitterTitle {
  font-family: D-DIN !important;
  font-size: 16px;
}

.row-padding-bottom-05 {
  padding-bottom: 0.5em;
}

.row-padding-bottom-10 {
  padding-bottom: 1em;
}

.row-padding-bottom-20 {
  padding-bottom: 2em;
}

.row-padding-bottom-30 {
  padding-bottom: 3em;
}

.icon {
  position: relative;
  top: 3px;
  font-size: 20px;
  margin-right: 15px;
}

.header-countRowsPopup {
  font-family: "D-DIN-700" !important;
  background: #bbdbfd !important;
  color: #030f40 !important;
  font-size: 12px !important;
  font-style: normal;
  align-items: center;
  padding: 12px 10px !important;
}

.body-countRowsPopup {
  font-family: "D-DIN" !important;
  color: #030f40 !important;
  font-size: 0.9rem !important;
  font-style: normal;
  align-items: center;
}

.footer-countRowsPopup {
  padding: 0.2rem !important;
}

.button-countRowsPopup {
  background: #eeeeee !important;
  color: #030f40 !important;
  width: 75px;
  height: 25px;
  padding: 1px !important;
  font-family: "D-DIN-700" !important;
  font-size: 12px !important;
  font-style: normal;
  align-items: center;
  border-radius: 5px;
  box-sizing: border-box;
  border: 0.5px solid #d0d8e6;
}

.button-countRowsPopup:focus {
  outline: none !important;
  box-shadow: none !important;
}

.button-countRowsPopup:focus,
.button-countRowsPopup:active {
  outline: none !important;
  box-shadow: none !important;
  border: 1px solid #d0d8e6 !important;
}

.button-countRowsPopup:hover {
  background-color: #deebf8 !important;
  text-decoration: none;
}

.save-button {
  color: #030f40;
  background-color: #9bcd41;
  border-color: #9bcd41;
  border-radius: 5px;
}

.save-button:hover {
  background-color: rgb(151 219 29);
  color: #fff;
}
</style>

<style lang="css">
@import "../../node_modules/@suez/custom-icons/suez-glyphicons.css";

.secondary-card {
  cursor: pointer !important;
}

.secondary-card .card-header {
  background-color: #f4f6fb !important;
}

.secondary-card .card-header:hover {
  background-color: #bbdbfd !important;
}
</style>
